import { isEmpty } from 'lodash';
import { StyleProp, TextStyle } from 'react-native';
import { MBText } from '@shared/components/MBText';
import { MBView, MBViewProps } from '@shared/components/MBView';

interface Props extends MBViewProps {
  beginning: string;
  end?: string;
  textStyle?: StyleProp<TextStyle>;
}

export function TruncateMiddle({ beginning, end = '', textStyle, ...otherProps }: Props) {
  return (
    <MBView row {...otherProps}>
      <MBText numberOfLines={1} style={[{ flexShrink: 1 }, truncationStyle, textStyle]}>
        {beginning}
      </MBText>
      {!isEmpty(end) && (
        <MBText numberOfLines={1} style={textStyle}>
          {end}
        </MBText>
      )}
    </MBView>
  );
}

const truncationStyle: TextStyle = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  // @ts-ignore
  display: 'inline-block',
};
